import React from "react";
import { Accordion } from "react-bootstrap";

export default function BlogFaqs({ data }) {
  return (
    <>
      <div className="blog-faqs">
        <Accordion defaultActiveKey="0">
          {data?.faqs && data?.faqs?.map((data, index) => (
            <Accordion.Item key={index} eventKey={`${index}`}>
              <Accordion.Header>
                {data?.question}
              </Accordion.Header>
              <Accordion.Body>
                {data?.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
}
